<template>
  <div class="d-flex flex-column flex-root medhop-login-page">
    <span class="login-orb login-orb--top" aria-hidden="true"></span>
    <span class="login-orb login-orb--bottom" aria-hidden="true"></span>
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid medhop-login-shell"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-signup-on': this.state == 'signup',
        'login-forgot-on': this.state == 'forgot',
      }"
      id="kt_login"
    >
      <div class="login-aside medhop-login-story" ref="cover">
        <div class="login-story-brand">
          <img src="/images/logo-medhop-transparent.png" alt="Medhop" />
        </div>

        <figure v-if="setting && setting.cover_image" class="login-clinic-cover">
          <img :src="setting.cover_image" :alt="`Identitas ${clinicName}`" />
          <figcaption>
            <img v-if="setting.logo" :src="setting.logo" alt="Logo klinik" />
            <span>{{ clinicName }}</span>
          </figcaption>
        </figure>

        <div class="login-story-copy">
          <span class="login-story-eyebrow">Healthcare Management Platform</span>
          <h1>Lebih cepat, terhubung, dan terpercaya.</h1>
          <p>
            Kelola pelayanan klinik, data pasien, jadwal, dan operasional dalam
            satu sistem yang aman dan mudah digunakan.
          </p>
          <div class="login-story-points" aria-label="Keunggulan Medhop">
            <span><i class="fas fa-shield-alt"></i> Data terlindungi</span>
            <span><i class="fas fa-heartbeat"></i> Operasional terintegrasi</span>
          </div>
        </div>

        <div class="login-story-footer">
          <span><i class="fas fa-globe-asia"></i> Indonesia</span>
          <span>Platform kesehatan digital</span>
        </div>
      </div>
      <div
        class="login-content medhop-login-content flex-row-fluid d-flex flex-column justify-content-center position-relative"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin medhop-auth-card">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signin_form"
              @submit.stop.prevent="checkUserLogin()"
            >
              <div class="login-card-heading">
                <div class="login-clinic-logo">
                  <img
                    src="/images/logo-medhop-transparent.png"
                    alt="Medhop"
                  />
                </div>
                <span class="login-card-eyebrow">{{ clinicName }}</span>
                <h2>Selamat datang</h2>
                <p>Masuk untuk melanjutkan ke dashboard Medhop.</p>
              </div>
              <div class="form-group medhop-form-group">
                <label for="medhop-login-email">Email</label>
                <div
                  class="medhop-input-shell"
                  id="example-input-group-1"
                  label=""
                  label-for="example-input-1"
                >
                  <i class="far fa-envelope" aria-hidden="true"></i>
                  <input
                    id="medhop-login-email"
                    class="form-control"
                    type="email"
                    placeholder="nama@email.com"
                    name="email"
                    ref="email"
                    v-model="form.email"
                  />
                </div>
              </div>
              <div class="form-group medhop-form-group">
                <div class="login-password-label">
                  <label for="medhop-login-password">Password</label>
                  <button
                    type="button"
                    class="login-forgot-link"
                    id="kt_login_forgot"
                    @click="showForm('forgot')"
                  >
                    Lupa password?
                  </button>
                </div>
                <div
                  class="medhop-input-shell medhop-password-shell"
                  id="example-input-group-2"
                  label=""
                  label-for="example-input-2"
                >
                  <i class="fas fa-lock" aria-hidden="true"></i>
                  <div class="input-group">
                    <input
                      id="medhop-login-password"
                      class="form-control"
                      :type="passwordIsVisible"
                      placeholder="Masukkan password"
                      name="password"
                      ref="password"
                      v-model="form.password"
                      autocomplete="off"
                    />
                    <div
                      class="input-group-prepend login-password-toggle"
                      role="button"
                      tabindex="0"
                      aria-label="Tampilkan atau sembunyikan password"
                      @click="
                        passwordIsVisible == 'password'
                          ? (passwordIsVisible = 'text')
                          : (passwordIsVisible = 'password')
                      "
                    >
                      <div class="input-group-text">
                        <template v-if="passwordIsVisible == 'password'">
                          <b-icon-eye-slash></b-icon-eye-slash>
                        </template>
                        <template v-if="passwordIsVisible == 'text'">
                          <b-icon-eye></b-icon-eye>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="mfaRequired" class="form-group medhop-form-group">
                <div class="login-password-label"><label for="medhop-login-mfa">{{ useRecoveryCode ? 'Kode pemulihan' : 'Kode authenticator' }}</label><button type="button" class="login-forgot-link" @click="useRecoveryCode=!useRecoveryCode">{{ useRecoveryCode ? 'Gunakan authenticator' : 'Gunakan kode pemulihan' }}</button></div>
                <div class="medhop-input-shell"><i class="fas fa-mobile-alt" aria-hidden="true"></i><input id="medhop-login-mfa" class="form-control" type="text" :maxlength="useRecoveryCode?9:6" :placeholder="useRecoveryCode?'XXXX-XXXX':'000000'" v-model="form.mfa_code" autocomplete="one-time-code" inputmode="numeric" /></div>
              </div>
              <div class="login-submit-wrap">
                <button
                  ref="kt_login_signin_submit"
                  class="btn medhop-login-submit"
                >
                  <span>Masuk ke dashboard</span>
                  <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </button>
                <p class="login-security-note">
                  <i class="fas fa-shield-alt" aria-hidden="true"></i>
                  Akses aman untuk tenaga dan pengelola fasilitas kesehatan
                </p>
              </div>
            </form>
          </div>
          <!--end::Signin-->
          <!--begin::Signup-->
          <div class="login-form login-signup medhop-auth-card">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signup_form"
              @submit.stop.prevent="onSubmitRegister()"
            >
              <div class="pb-13 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                >
                  Buat Akun
                </h3>
                <p class="text-muted font-weight-bold font-size-h4">
                  Lengkapi data untuk membuat akun Medhop
                </p>
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="text"
                  placeholder="Nama lengkap"
                  name="fullname"
                  ref="fullname"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="email"
                  placeholder="Email"
                  name="email"
                  ref="remail"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Password"
                  name="password"
                  ref="rpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Confirm password"
                  name="cpassword"
                  ref="cpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="checkbox mb-0">
                  <input type="checkbox" name="agree" />
                  <span class="mr-2"></span>
                  I Agree the
                  <a href="#" class="ml-2">terms and conditions</a>.
                </label>
              </div>
              <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
                <button
                  ref="kt_login_signup_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                  style="width: 150px"
                >
                  Daftar
                </button>
                <button
                  type="button"
                  id="kt_login_signup_cancel"
                  class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                  @click="showForm('signin')"
                >
                  Batal
                </button>
              </div>
            </form>
          </div>
          <!--end::Signup-->
          <!--begin::Forgot-->
          <div class="login-form login-forgot medhop-auth-card">
            <!--begin::Form-->
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_forgot_form"
              ref="kt_login_forgot_form"
            >
              <div class="login-card-heading login-forgot-heading">
                <div class="login-reset-icon">
                  <i class="fas fa-key" aria-hidden="true"></i>
                </div>
                <span class="login-card-eyebrow">Pemulihan akun</span>
                <h2>Lupa password?</h2>
                <p>Masukkan email Anda dan kami akan mengirimkan instruksi reset.</p>
              </div>
              <div class="form-group medhop-form-group">
                <label for="medhop-reset-email">Email</label>
                <input
                  id="medhop-reset-email"
                  class="form-control medhop-standalone-input"
                  type="email"
                  placeholder="Email"
                  name="email"
                  autocomplete="off"
                  v-model="reset.email"
                />
              </div>
              <span class="text-danger">{{ error.email }}</span>
              <div class="login-reset-actions">
                <button
                  @click="forgetPassword"
                  type="button"
                  id="kt_login_forgot_submit"
                  class="btn medhop-login-submit"
                >
                  Kirim
                </button>
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  class="btn medhop-login-secondary"
                  @click="showForm('signin')"
                >
                  Batal
                </button>
              </div>
            </form>
          </div>
          <!--end::Forgot-->
        </div>
        <!--begin::Content footer-->
        <!-- class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0" -->
        <div class="medhop-login-footer">
          <p>
            © {{ year }} Medhop Software. All Rights Reserved. <br />
            Powered by Wellmagic Media Digital.
          </p>
          <!-- <p>Powered by Wellmagic Media Digital.</p> -->
          <!-- <a href="#" class="text-dark font-weight-bolder font-size-h5"
            >Terms</a
          >
          <a href="#" class="text-dark ml-10 font-weight-bolder font-size-h5"
            >Plans</a
          > -->
          <!-- <a href="#" class="text-dark font-weight-bolder font-size-h5"
            >Hubungi Kami</a
          > -->
        </div>
        <!--end::Content footer-->
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";

.medhop-login-page {
  --login-navy: var(--skin-deep);
  --login-blue: var(--skin-primary);
  --login-teal: var(--skin-secondary);
  --login-border: #e7edf4;
  --login-muted: #6b7280;
  position: relative;
  min-height: 100vh;
  padding: 24px;
  overflow: hidden;
  background:
    radial-gradient(circle at 8% 10%, rgba(var(--skin-secondary-rgb), 0.12), transparent 24%),
    radial-gradient(circle at 92% 88%, rgba(var(--skin-primary-rgb), 0.12), transparent 26%),
    #f2f5fb;
  font-family: "Poppins", "Inter", sans-serif;

  .login-orb {
    position: absolute;
    z-index: 0;
    width: 220px;
    height: 220px;
    border: 34px solid rgba(var(--skin-primary-rgb), 0.08);
    border-radius: 50%;
    pointer-events: none;
  }

  .login-orb--top {
    top: -142px;
    left: -92px;
  }

  .login-orb--bottom {
    right: -108px;
    bottom: -142px;
    border-color: rgba(var(--skin-secondary-rgb), 0.09);
  }
}

.medhop-login-shell {
  position: relative;
  z-index: 1;
  width: min(1280px, 100%);
  height: calc(100vh - 48px);
  margin: auto;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(var(--skin-deep-rgb), 0.12);
}

.login.login-1.medhop-login-shell .medhop-login-story {
  position: relative;
  display: flex;
  flex: 1 1 56%;
  width: auto;
  max-width: none;
  min-height: 620px;
  padding: 38px 46px;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  background-image:
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.88) 72%),
    linear-gradient(135deg, rgba(var(--skin-secondary-rgb), 0.28), rgba(var(--skin-primary-rgb), 0.24) 52%, rgba(var(--skin-deep-rgb), 0.35)) !important;
  background-color: #e7f3f7 !important;

  &::before,
  &::after {
    position: absolute;
    content: "";
    border-radius: 50%;
    pointer-events: none;
  }

  &::before {
    top: -150px;
    right: -115px;
    width: 420px;
    height: 420px;
    border: 64px solid rgba(255, 255, 255, 0.25);
  }

  &::after {
    right: 17%;
    bottom: 21%;
    width: 120px;
    height: 120px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.38), rgba(255, 255, 255, 0));
    filter: blur(2px);
  }
}

.login-story-brand,
.login-story-copy,
.login-story-footer {
  position: relative;
  z-index: 1;
}

.login-story-brand img {
  width: 172px;
  height: 48px;
  object-fit: contain;
  object-position: left center;
}

.login-clinic-cover {
  position: relative;
  z-index: 2;
  width: min(100%, 520px);
  height: clamp(185px, 29vh, 285px);
  margin: 22px 0 18px;
  overflow: hidden;
  border: 5px solid rgba(255, 255, 255, .78);
  border-radius: 22px;
  box-shadow: 0 18px 38px rgba(var(--skin-deep-rgb), .18);
}
.login-clinic-cover > img { width: 100%; height: 100%; object-fit: cover; object-position: center 62%; }
.login-clinic-cover figcaption {
  position: absolute; right: 12px; bottom: 12px; left: 12px;
  min-height: 44px; padding: 8px 12px; display: flex; align-items: center; gap: 10px;
  color: #fff; font-size: 13px; font-weight: 750;
  background: rgba(13, 43, 72, .82); border: 1px solid rgba(255,255,255,.28); border-radius: 12px;
  backdrop-filter: blur(9px);
}
.login-clinic-cover figcaption img { width: 34px; height: 28px; object-fit: contain; border-radius: 5px; background: #fff; }

.login-story-copy {
  max-width: 500px;
  margin: auto 0 24px;

  .login-story-eyebrow {
    display: inline-flex;
    margin-bottom: 16px;
    color: var(--login-teal);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  h1 {
    max-width: 480px;
    margin: 0 0 18px;
    color: #172235;
    font-size: clamp(34px, 4vw, 54px);
    font-weight: 700;
    line-height: 1.12;
    letter-spacing: -0.04em;
  }

  p {
    max-width: 470px;
    margin: 0;
    color: #536277;
    font-size: 15px;
    line-height: 1.8;
  }
}

.login-story-points {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 26px;

  span {
    display: inline-flex;
    min-height: 38px;
    padding: 9px 13px;
    align-items: center;
    gap: 8px;
    border: 1px solid rgba(var(--skin-primary-rgb), 0.12);
    border-radius: 999px;
    color: var(--login-navy);
    background: rgba(255, 255, 255, 0.66);
    font-size: 12px;
    font-weight: 600;
    backdrop-filter: blur(10px);
  }

  i {
    color: var(--login-teal);
  }
}

.login-story-footer {
  display: flex;
  color: #5f6d80;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 500;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  i {
    color: var(--login-teal);
  }
}

.login.login-1.medhop-login-shell .medhop-login-content {
  flex: 0 1 44%;
  width: auto;
  min-width: 410px;
  padding: 48px 36px 32px;
  overflow-y: auto !important;
  background: linear-gradient(180deg, #fbfcff, #f7f9fc);

  .flex-center {
    width: 100%;
    margin: auto 0;
  }
}

.login.login-1 .medhop-auth-card {
  width: min(100%, 440px);
  padding: 34px 36px 30px;
  border: 1px solid rgba(231, 237, 244, 0.92);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 50px rgba(var(--skin-deep-rgb), 0.1);

  .form {
    width: 100%;
    max-width: none;
  }
}

.login-card-heading {
  margin-bottom: 28px;

  .login-clinic-logo {
    display: flex;
    width: 100%;
    height: 58px;
    margin-bottom: 20px;
    align-items: center;

    img {
      max-width: 190px;
      max-height: 58px;
      object-fit: contain;
      object-position: left center;
    }
  }

  .login-card-eyebrow {
    display: block;
    margin-bottom: 7px;
    color: var(--login-teal);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.13em;
    text-transform: uppercase;
  }

  h2 {
    margin: 0 0 8px;
    color: #172235;
    font-size: 29px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.025em;
  }

  p {
    margin: 0;
    color: var(--login-muted);
    font-size: 13px;
    line-height: 1.65;
  }
}

.medhop-form-group {
  margin-bottom: 18px;

  > label,
  .login-password-label label {
    margin: 0 0 8px;
    color: #344258;
    font-size: 12px;
    font-weight: 600;
  }
}

.login-password-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-forgot-link {
  padding: 0;
  border: 0;
  color: var(--login-blue);
  background: transparent;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;

  &:hover,
  &:focus {
    color: var(--login-teal);
    text-decoration: underline;
    outline: none;
  }
}

.medhop-input-shell {
  position: relative;
  display: flex;
  min-height: 50px;
  align-items: center;
  border: 1px solid #dfe7f0;
  border-radius: 14px;
  background: #f8fafc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

  > i {
    position: absolute;
    z-index: 2;
    left: 16px;
    color: #91a0b5;
    font-size: 14px;
  }

  &:focus-within {
    border-color: rgba(var(--skin-secondary-rgb), 0.72);
    background: #fff;
    box-shadow: 0 0 0 4px rgba(var(--skin-secondary-rgb), 0.1);

    > i {
      color: var(--login-teal);
    }
  }

  .form-control {
    height: 48px;
    padding: 0 16px 0 43px !important;
    border: 0 !important;
    border-radius: 14px !important;
    color: #253247;
    background: transparent !important;
    box-shadow: none !important;
    font-size: 13px;

    &::placeholder {
      color: #9aa8bb;
    }
  }
}

.medhop-password-shell {
  .input-group {
    width: 100%;
  }

  .form-control {
    padding-right: 50px !important;
  }
}

.login-password-toggle {
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .input-group-text {
    padding: 0;
    border: 0 !important;
    color: #728197;
    background: transparent !important;
  }
}

.login-submit-wrap {
  margin-top: 24px;
}

.medhop-login-submit {
  display: inline-flex !important;
  width: 100%;
  min-height: 50px;
  padding: 0 20px !important;
  border: 0 !important;
  border-radius: 14px !important;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #fff !important;
  background: linear-gradient(135deg, var(--login-navy), var(--login-blue), var(--login-teal)) !important;
  box-shadow: 0 12px 25px rgba(var(--skin-primary-rgb), 0.23);
  font-size: 13px !important;
  font-weight: 700 !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover,
  &:focus {
    color: #fff !important;
    transform: translateY(-1px);
    box-shadow: 0 16px 30px rgba(var(--skin-primary-rgb), 0.28);
  }
}

.login-security-note {
  display: flex;
  margin: 18px 0 0;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  color: #8995a7;
  font-size: 10px;
  line-height: 1.5;
  text-align: center;

  i {
    margin-top: 2px;
    color: var(--login-teal);
  }
}

.login-reset-icon {
  display: inline-flex;
  width: 48px;
  height: 48px;
  margin-bottom: 20px;
  border-radius: 14px;
  align-items: center;
  justify-content: center;
  color: var(--login-teal);
  background: rgba(var(--skin-secondary-rgb), 0.1);
  font-size: 18px;
}

.medhop-standalone-input {
  height: 50px !important;
  padding: 0 16px !important;
  border: 1px solid #dfe7f0 !important;
  border-radius: 14px !important;
  background: #f8fafc !important;
  box-shadow: none !important;

  &:focus {
    border-color: rgba(var(--skin-secondary-rgb), 0.72) !important;
    background: #fff !important;
    box-shadow: 0 0 0 4px rgba(var(--skin-secondary-rgb), 0.1) !important;
  }
}

.login-reset-actions {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  margin-top: 24px;
}

.medhop-login-secondary {
  min-height: 50px;
  padding: 0 18px !important;
  border: 1px solid #dfe7f0 !important;
  border-radius: 14px !important;
  color: var(--login-navy) !important;
  background: #fff !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.medhop-login-footer {
  display: flex !important;
  margin-top: 24px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #8b97a8;
  font-size: 10px;
  text-align: center;

  p {
    margin: 0;
    font-size: inherit !important;
  }
}

@media (max-width: 991.98px) {
  .medhop-login-page {
    padding: 16px;
    overflow: auto;
  }

  .medhop-login-shell {
    min-height: calc(100vh - 32px);
  }

  .login.login-1.medhop-login-shell .medhop-login-story {
    display: flex !important;
    flex: 0 0 auto;
    width: 100%;
    min-height: 220px;
    padding: 28px 32px;
  }

  .login-story-copy {
    max-width: 620px;
    margin: 34px 0 0;

    h1 {
      font-size: 34px;
    }

    p,
    .login-story-points {
      display: none;
    }
  }

  .login-story-footer {
    display: none;
  }

  .login.login-1.medhop-login-shell .medhop-login-content {
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    padding: 28px 22px;
  }
}

@media (max-width: 575.98px) {
  .medhop-login-page {
    padding: 0;
    background: #f7f9fc;
  }

  .medhop-login-shell {
    min-height: 100vh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .login.login-1.medhop-login-shell .medhop-login-story {
    min-height: 170px;
    padding: 24px;
  }

  .login-story-brand img {
    width: 140px;
    height: 38px;
  }

  .login-story-copy {
    margin-top: 24px;

    .login-story-eyebrow {
      margin-bottom: 8px;
      font-size: 9px;
    }

    h1 {
      font-size: 26px;
    }
  }

  .login.login-1.medhop-login-shell .medhop-login-content {
    padding: 20px 14px 18px;
    justify-content: flex-start !important;
  }

  .login.login-1 .medhop-auth-card {
    padding: 26px 22px;
    border-radius: 20px;
    box-shadow: 0 12px 34px rgba(var(--skin-deep-rgb), 0.08);
  }

  .login-card-heading h2 {
    font-size: 25px;
  }

  .login-reset-actions {
    grid-template-columns: 1fr;
  }
}
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import ApiService from "@/core/services/api.service.js";
import ProductConfigurationService from "@/core/services/product-configuration.service.js";
import JwtService from "@/core/services/jwt.service";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import ImageComponent from "@/component/general/ImageComponent.vue";
import Swal from "sweetalert2";
import moment from "moment";

import myCaptcha from "@/component/general/MyCaptcha.vue";

import module from "@/core/modules/CrudModule.js";
import moduleSaas from "@/core/modules/CrudSaasModule.js";
import validation from "@/core/modules/ValidationModule.js";
import axios from "axios";
import qs from "querystring";
import {
  getConfiguration,
  setConfiguration,
  getDbConfig,
} from "@/core/services/jwt.service.js";
import {
  UPDATE_SS_CLIENT_ID,
  UPDATE_SS_CLIENT_SECRET,
  UPDATE_SS_ORGANIZATION_ID,
  UPDATE_SS_ACCESS_TOKEN,
} from "@/core/services/store/tokenstore.module";
import {
  setTokenBridge,
  setTokenSatuSehat,
  setRefreshTokenBridge,
  setSsOrganizationId,
  setSsLocationDefault,
  setSsSecret,
  setSsId,
} from "@/core/services/jwt.service.js";

export default {
  name: "login-1",

  data() {
    return {
      state: "signin",
      form: {
        email: "",
        password: "",
        mfa_code: "",
      },
      mfaRequired: false,
      useRecoveryCode: false,
      reset: {
        email: "",
        subdomain: "",
      },
      error: {
        email: "",
      },
      passwordIsVisible: "password",
      year: moment().format("YYYY"),
      background_image: getConfiguration() != null ? "" : "",
      dataLoaded: false,
      dbConfig: getDbConfig(),
      dbConfigParams: "",
      setting: {},
    };
  },

  components: {
    ImageComponent,
    myCaptcha,
  },

  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),
    clinicName() {
      return (this.setting && this.setting.clinic_name) || "Portal Klinik"
    },
  },

  mounted() {
    // if (this.background_image == "") {
    //   this.getSetting();
    // }else{
    //   this.getSetting();
    // }
    this.getDbConfiguration();

    const signin_form = KTUtil.getById("kt_login_signin_form");
    const signup_form = KTUtil.getById("kt_login_signup_form");
    const forgot_form = KTUtil.getById("kt_login_forgot_form");

    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Username is required",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Full name is required",
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required",
            },
            identical: {
              compare: function () {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "The password and its confirm are not the same",
            },
          },
        },
        agree: {
          validators: {
            notEmpty: {
              message: "You should agree terms and conditions",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv2 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email wajib diisi",
            },
            emailAddress: {
              message: "Format Email tidak sesuai, periksa kembali email anda",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },

  methods: {
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },

    checkUserLogin() {
      ApiService.post("check-user-login", this.form)
        .then((response) => {
          if (response.data.status == true) {
            this.onSubmitLogin();
          } else if (response.data.status == 404) {
            Swal.fire({
              title: "Gagal",
              text: "Akun tidak terdaftar",
              icon: "error",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            Swal.fire({
              title: "Gagal",
              text: "User yang login sudah mencapai batas maksimal",
              icon: "error",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((error) => {
          const apiIsUnavailable = !error.response;

          Swal.fire({
            title: "Gagal terhubung",
            text: apiIsUnavailable
              ? "Layanan Medhop sedang tidak dapat dihubungi. Pastikan server lokal sudah dijalankan, lalu coba kembali."
              : "Terjadi gangguan saat memeriksa akun. Silakan coba kembali.",
            icon: "error",
            confirmButtonText: "Mengerti",
          });

          if (process.env.NODE_ENV !== "production") {
            console.error("Login pre-check failed:", error);
          }
        });
    },

    async forgetPassword() {
      this.error.email = "";

      let dataJson = JSON.parse(localStorage.getItem("tenantconfig"));

      this.reset.subdomain = dataJson.domain;

      let response = await module.submit(this.reset, "/reset-password");
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(
          response.success.title,
          response.success.message,
          "success"
        ).then((result) => {
          this.showForm("signin");
        });
      }
    },

    onSubmitLogin() {
      // this.fv.validate();
      SwalLoading.fire();

      // this.fv.on("core.form.valid", () => {
      var email = this.form.email;
      var password = this.form.password;

      // Clear stale local authentication before requesting a new token.
      // A login attempt must never revoke through the network: that request can
      // race with the new OAuth request and purge the token that was just issued.
      this.$store.dispatch(LOGOUT, { revoke: false });

      // set spinner to submit button
      // const submitButton = this.$refs["kt_login_signin_submit"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { email, password, mfa_code: this.useRecoveryCode ? "" : this.form.mfa_code, recovery_code: this.useRecoveryCode ? this.form.mfa_code : "" })
          // go to which page after successfully login
          .then(() => {
            let access_right, position_right;
            ApiService.get("users/me").then((data) => {
              if (!data || !data.data || !data.data.data) {
                SwalLoading.close();
                return;
              }
              const userData = data.data.data;
              if (userData.must_change_password) {
                JwtService.setUser(JSON.stringify(userData));
                SwalLoading.close();
                this.$router.push({ name: "profile-change-password" });
                return;
              }
              ApiService.get("users/" + userData.user_id).then(
                (response) => {
                  if (data.data.data.position_id) {
                    ApiService.get(
                      "positions/" + data.data.data.position_id
                    ).then((result) => {
                      access_right = response.data.meta.access_right_display;
                      position_right = result.data.meta.access_right_display;

                      let merge = [...access_right, ...position_right];

                      window.localStorage.setItem(
                        "access_right_display",
                        JSON.stringify(merge)
                      );

                      let user = data.data.data;
                      // user.access_right = access_right + ", " + position_right;
                      JwtService.setUser(JSON.stringify(user));

                      this.$router.push({ name: "dashboard" });
                      SwalLoading.close();
                    });
                  } else if (!data.data.data.position_id) {
                    window.localStorage.setItem(
                      "access_right",
                      response.data.meta.access_right
                    );

                    window.localStorage.setItem(
                      "access_right_display",
                      JSON.stringify(response.data.meta.access_right_display)
                    );

                    let user = data.data.data;
                    access_right = response.data.meta.access_right;
                    user.access_right = response.data.meta.access_right;
                    JwtService.setUser(JSON.stringify(user));

                    this.$root.$emit("setMenuActive");

                    // get data subscribe
                    // let strg = JSON.parse(localStorage.getItem("tenantconfig"));
                    // let subs_end = strg.end_date;

                    // let current_date = window.medhopToday();

                    for (let z = 0; z < 20; z++) {
                      if (z == 19) {
                        // if (subs_end < current_date) {
                        //   let url = window.location.href;
                        //   url = url.split("/");

                        //     Swal.fire({
                        //       icon: "warning",
                        //       title: "Perhatian",
                        //       text: "Masa aktif anda telah habis, silahkan lakukan perpanjangan",
                        //       timerProgressBar: true,
                        //       timer: 5000,
                        //       showConfirmButton: false,
                        //     }).then(() => {
                        //       router
                        //         .push({
                        //           path: "/subscribe/package",
                        //         })
                        //         .catch(() => true);
                        //     });

                        // } else {
                        this.$router.push({ name: "dashboard" });
                        SwalLoading.close();
                        // }
                      }
                    }
                  }
                }
              );
            });

            // this.$router.push({ name: "dashboard" });
            // SwalLoading.close();
            // Integration tokens are session-scoped and must only be requested
            // after the clinic user has authenticated successfully.
            this.getSetting(true);
          })
          .catch((error) => {
            SwalLoading.close();
            const oauthError = error && error.response && error.response.data && error.response.data.error;
            if (oauthError === "mfa_required") {
              this.mfaRequired = true;
              this.form.mfa_code = "";
              this.$nextTick(() => document.getElementById("medhop-login-mfa") && document.getElementById("medhop-login-mfa").focus());
              Swal.fire({ title: "Verifikasi dua faktor", text: "Masukkan kode dari aplikasi authenticator atau kode pemulihan.", icon: "info" });
            }
          });

        // submitButton.classList.remove(
        //   "spinner",
        //   "spinner-light",
        //   "spinner-right"
        // );
      }, 100);
      // });

      // this.fv.on("core.form.invalid", () => {
      //   Swal.fire({
      //     title: "",
      //     text: "Please, provide correct data!",
      //     icon: "error",
      //     confirmButtonClass: "btn btn-secondary",
      //     heightAuto: false,
      //   });
      // });
    },

    onSubmitRegister() {
      this.fv1.validate();

      this.fv1.on("core.form.valid", () => {
        const email = this.$refs.remail.value;
        const password = this.$refs.rpassword.value;

      // Registration starts from a clean local session without an asynchronous
      // revoke request racing the following authentication flow.
      this.$store.dispatch(LOGOUT, { revoke: false });

        // set spinner to submit button
        const submitButton = this.$refs["kt_login_signup_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        // dummy delay
        setTimeout(() => {
          // send register request
          this.$store
            .dispatch(REGISTER, {
              email: email,
              password: password,
            })
            .then(() => this.$router.push({ name: "dashboard" }));

          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }, 2000);
      });

      this.fv1.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },

    async getDbConfiguration() {
      const hostname = window.location.hostname;
      let domain = hostname;

      // Browser resolves every *.localhost hostname to the local machine. Convert
      // that development-only suffix to the domain stored by the SaaS API.
      if (hostname.endsWith(".localhost")) {
        const subdomain = hostname.slice(0, -".localhost".length);
        domain = `${subdomain}.medhop.id`;
      } else if (hostname === "localhost") {
        // The checked-in local stack provisions Klinik Sehati as its review
        // tenant. Keep plain localhost usable without requiring a subdomain.
        domain = "sehatilocal.medhop.id";
      }

      let response = await moduleSaas.getDbConfig(
        `get-db-config?domain=${domain}`
      );

      if (response != null) {
        let dbconfig = response;
        localStorage.setItem("tenantconfig", JSON.stringify(response));
        ApiService.setDbConfigHeader(dbconfig);
        await ProductConfigurationService.syncFromTenantConfig(response);
        this.getSetting();
      } else {
        this.$router.push("/404");
      }
    },

    async getSetting(loadIntegrations = false) {
      let response = await module.get("settings-no-auth/1");
      if (response != null) {
        this.dataLoaded = true;
        this.background_image = response.cover_image;
        this.setting = response;
        setConfiguration(JSON.stringify(response));
        if (loadIntegrations) {
          this.getSSAccessToken();
        }
      }
    },

    async getSSAccessToken() {
      // Get Token
      const conf = JwtService.getConfiguration();
      if (!conf || !conf.satu_sehat_clinic_id) {
        return;
      }
      let login_data = qs.stringify({
        username: "medhop-api-integration@medhop.id",
        password: "wm547u53h47",
        grant_type: "password",
        scope: "*",
        client_id: JwtService.getConfiguration().client_id,
        client_secret: JwtService.getConfiguration().client_secret,
      });
      ApiService.post("oauth/token", login_data)
        .then(({ data }) => {
          // let response = await module.get("satu-sehat-settings/1");
          // if (response != null) {
          //   console.log("ssaccess token", response);
          // }
          ApiService.setHeader(data.access_token);
          ApiService.get("satu-sehat-settings/1").then((response) => {
            let access_token = response.data.data;
            this.$store.dispatch(UPDATE_SS_CLIENT_ID, access_token.client_id);
            this.$store.dispatch(
              UPDATE_SS_CLIENT_SECRET,
              access_token.client_secret
            );
            this.$store.dispatch(
              UPDATE_SS_ORGANIZATION_ID,
              access_token.organization_id
            );

            setSsSecret(access_token.client_secret);
            setSsId(access_token.client_id);

            // Login To API Bridge & Satu Sehat
            let login_data_api_bridge = {
              username: "medhop@wellmagic.id",
              password: "wm547u53h47",
              grant_type: "password",
              scope: "*",
              ss_client_id: access_token.client_id,
              ss_client_secret: access_token.client_secret,
              satu_sehat_clinic_id:
                JwtService.getConfiguration().satu_sehat_clinic_id,
            };

            setSsLocationDefault(access_token.location_default);
            setSsOrganizationId(access_token.organization_id);
            ApiService.bridge
              .post("oauth/token", login_data_api_bridge)
              .then((response) => {
                let data = response.data;
                setTokenBridge(data.bridge.access_token);
                setRefreshTokenBridge(data.bridge.refresh_token);
                setTokenSatuSehat(data.satusehat.access_token);
                this.$store.dispatch(
                  UPDATE_SS_ACCESS_TOKEN,
                  data.satusehat.access_token
                );
                ApiService.setHeaderBridge(data.bridge.access_token);
              });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.color-sample {
  color: rgb(242, 242, 243);
}

.cover-image-width {
  width: 100%;
}

.bg-base {
  background-color: var(--skin-primary) !important;
  color: white !important;
}
.text-base-orange {
  color: #f47b20 !important;
}
</style>
.bg-base {
  background-color: var(--skin-primary) !important;
  color: white !important;
}
.text-base-orange {
  color: #f47b20 !important;
}
</style>
